import React from 'react';
import PropTypes from 'prop-types';
import application_contants from '../../contants/application_contants';
// replace these with your actual SVGs or image imports

// import LightningGreen from './assets/lightning-green.svg'
// import LightningOrange from './assets/lightning-orange.svg'
// import SmileIcon from './assets/smile.svg'
// import Avatar1 from './assets/avatar1.jpg'
// import Avatar2 from './assets/avatar2.jpg'
// import Avatar3 from './assets/avatar3.jpg'

export default function Participate({ section_id }) {
  const round1 = [
    { icon: application_contants.Zap, label: 'Participants register for the Challenge and gain access to the SYSPIN dataset and English + Gujarati SPICOR TTS corpora.' },
    { icon: application_contants.Zap, label: 'Teams develop and submit TTS models focusing on accent and style transfer.' },
    { icon: application_contants.Zap, label: 'Submissions are evaluated based on innovation, technical feasibility, accent/style transfer quality, and alignment with the problem statement.' },
    { icon: application_contants.Zap, label: 'Up to 10 teams will be shortlisted for the Round 2 based on their submissions. ' }
  ]
  const round2 = [
    { icon: application_contants.Zap, label: 'Shortlisted teams will be invited to an offline event where they will present their solutions to a panel of judges and an audience.' },
    { icon: application_contants.Zap, label: 'The final round will include live demonstrations of the TTS systems, Q&A sessions with judges, and detailed evaluations of each solution.' },
    { icon: application_contants.Zap, label: 'The event will conclude with an award ceremony to recognize and reward the top-performing teams for their contributions to advancing TTS technology for low-resource Indian languages.' }
  ]
  const audiences = [
    { icon: application_contants.student, label: 'Academicians' },
    { icon: application_contants.startups, label: 'Startups' },
    { icon: application_contants.freelancer, label: 'Students' },
    { icon: application_contants.industry, label: 'Industry' }
  ]

  return (
    <section id={section_id} className="participate-section">
      <div className="participate-header">
        {/* <p className="participate-subtitle title-navy-blue">We know what you want</p> */}
        <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">How to Participate</h2>
      </div>

      <div className="participate-rounds">
        <div className="participate-round">
          <h3 className="h2-medium section-title title-navy-blue pb-2 about-title">Round 1 (Online)</h3>
          {round1.map(item => (
            <div key={item.label} className="round-item">
              <img src={item.icon} alt="" />
              <span className="jostRegular h5-small section-title title-dark-grey about-readmore-text">{item.label}</span>
            </div>
          ))}
        </div>
        <div className="participate-round">
          <h3 className="h2-medium section-title title-navy-blue pb-2 about-title">Round 2 (Offline)</h3>
          {round2.map(item => (
            <div key={item.label} className="round-item">
              <img src={item.icon} alt="" />
              <span className="jostRegular h5-small section-title title-dark-grey about-readmore-text">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      <p className="team-size jostRegular h5-small section-title ">Who Can Participate</p>

      <div className="participate-audiences">
        {audiences.map(a => (
          <div key={a.label} className="audience-item">
            <img src={a.icon} alt="" />
            <span className="team-size jostRegular h5-small section-title ">{a.label}</span>
          </div>
        ))}
      </div>


{/* Callout */}
      <div className="eval-callout section-title jostRegular h1-medium">
        We are promoting diversity and inclusion. We encourage applications from individuals of all backgrounds, including those from technologically underrepresented groups.
      </div>
        {/* Get In TOUCH VIA EMAIL  */}
      {/* <div className="participate-cta">
        <div className="avatars">
          <img src={application_contants.avatar1} alt="Avatar 1" />
          <img src={application_contants.avatar2} alt="Avatar 2" />
          <img src={application_contants.avatar3} alt="Avatar 3" />
        </div>
        <h3 className="h2-medium section-title title-navy-blue pb-2 title">Still have questions?</h3>
        <p className="jostRegular h5-small section-title title-dark-grey">Can’t find the answer you’re looking for? Please chat to our friendly team.</p>
        <a href="/contact" className="btn-contact jostRegular h5-small">Get in touch</a>
      </div> */}
    </section>
  )
}

Participate.propTypes = {
  section_id: PropTypes.string.isRequired
}
